import React, { ReactElement, useEffect, useRef, useState } from 'react';
import styled from 'styled-components/macro';
import SignatureCanvas from 'react-signature-canvas';
import Prompt from './Shared/Prompt';
import QuestionWrapper from './Shared/QuestionWrapper';
import ReactSignatureCanvas from 'react-signature-canvas';
import { Button } from '@televet/kibble-ui';

interface ISignatureInput {
  index: number;
  prompt: string;
  isRequired: boolean;
}

const SignatureInput = ({ index, prompt, isRequired }: ISignatureInput): ReactElement => {
  const signatureContainerRef = useRef<HTMLDivElement | null>(null);
  const signatureCanvasRef = useRef<ReactSignatureCanvas | null>(null);
  const [signatureContainerWidth, setSignatureContainerWidth] = useState('');

  useEffect(() => {
    const container = signatureContainerRef.current;
    if (container) {
      setSignatureContainerWidth(getComputedStyle(container).width);
    }
  }, [signatureContainerRef]);

  return (
    <QuestionWrapper index={index}>
      <Prompt prompt={prompt} isRequired={isRequired} />
      <br />
      <NamePrompt>Your Printed Name:</NamePrompt>
      <StyledInput type="text" placeholder="" />
      <SignatureContainer ref={signatureContainerRef}>
        <SignatureCanvas ref={signatureCanvasRef} canvasProps={{ width: signatureContainerWidth, height: 200 }} />
      </SignatureContainer>
      <ApplySignature>
        <Button
          disabled={false}
          onClick={(): void => {
            if (signatureCanvasRef.current) signatureCanvasRef.current.clear();
          }}
          data-mixpanel-name="Apply Signature button"
          data-html2canvas-ignore
          variant="tertiary"
        >
          Clear Signature
        </Button>
        <Button data-html2canvas-ignore>Apply Signature</Button>
      </ApplySignature>
    </QuestionWrapper>
  );
};

export default SignatureInput;

const SignatureContainer = styled.div`
  border: solid 1px #d2d2d2;
  width: 100%;
`;

const StyledInput = styled.input`
  width: 100%;
  padding: 12px 20px;
  margin: 8px 0;
  box-sizing: border-box;
  font-size: 1em;
  border-radius: 7px;
  border: solid 1px #d2d2d2;
`;

const NamePrompt = styled.p`
  font-size: 18px;
  font-weight: 600;
  font-stretch: normal;
  font-style: normal;
  line-height: normal;
  letter-spacing: 0.16px;
  color: #73747d;
`;

const ApplySignature = styled.div`
  display: flex;
  justify-content: space-evenly;
  padding-top: 20px;
`;
